import React from 'react';
import { Card, Statistic, Row, Col } from 'antd';
import { InboxOutlined, RocketOutlined } from '@ant-design/icons';

interface StockStateWidgetProps {
  stockItemsCost: number;
  incomingItemsCost: number;
}

const StockStateWidget: React.FC<StockStateWidgetProps> = ({
  stockItemsCost,
  incomingItemsCost,
}) => {
  return (
    <Card title="Stock State" bordered={false} className="dashboard-card">
      <Row gutter={[16, 24]} justify="space-around">
        <Col xs={24}>
          <Statistic
            title="Current Stock Value"
            value={stockItemsCost}
            precision={2}
            valueStyle={{ color: '#1890ff', fontSize: '24px' }}
            prefix={<InboxOutlined />}
            suffix="$"
          />
        </Col>
        <Col xs={24}>
          <Statistic
            title="Items on the Way"
            value={incomingItemsCost}
            precision={2}
            valueStyle={{ color: '#722ed1', fontSize: '24px' }}
            prefix={<RocketOutlined />}
            suffix="$"
          />
        </Col>
      </Row>
    </Card>
  );
};

export default StockStateWidget;
